/**
 * KAN-928: серии графика "Лиды по дням" и их видимость.
 * Столбцы "Лиды" (без отказов), "Отказ", "Продажи" на левой оси, линия "Отправлено" на правой.
 * Скрытые серии хранятся списком ключей в localStorage (ключ с версией); мусор отбрасывается.
 */
import type { CrmDailyMetric } from '@/types/crm';
import { CRM_STATS_METRIC_LABEL } from './crmStats';

export type CrmStatsChartSeriesKey = Extract<CrmDailyMetric, 'leads' | 'leads_refused' | 'won' | 'sent'>;

export interface CrmStatsChartSeries {
  key: CrmStatsChartSeriesKey;
  kind: 'bar' | 'line';
  axis: 'left' | 'right';
  /** Короткая подпись переключателя. */
  label: string;
  /** Подпись в легенде и подсказке. */
  name: string;
  color: string;
}

export const CRM_STATS_CHART_SERIES: readonly CrmStatsChartSeries[] = [
  {
    key: 'leads',
    kind: 'bar',
    axis: 'left',
    label: CRM_STATS_METRIC_LABEL.leads,
    name: `${CRM_STATS_METRIC_LABEL.leads} (без отказов)`,
    color: '#3b82f6',
  },
  {
    key: 'leads_refused',
    kind: 'bar',
    axis: 'left',
    label: CRM_STATS_METRIC_LABEL.leads_refused,
    name: CRM_STATS_METRIC_LABEL.leads_refused,
    color: '#ef4444',
  },
  {
    key: 'won',
    kind: 'bar',
    axis: 'left',
    label: CRM_STATS_METRIC_LABEL.won,
    name: CRM_STATS_METRIC_LABEL.won,
    color: '#16a34a',
  },
  {
    key: 'sent',
    kind: 'line',
    axis: 'right',
    label: CRM_STATS_METRIC_LABEL.sent,
    name: CRM_STATS_METRIC_LABEL.sent,
    color: '#94a3b8',
  },
];

export const CRM_STATS_CHART_STORAGE_KEY = 'crm-stats-chart-hidden:v1';

const SERIES_KEYS = new Set<string>(CRM_STATS_CHART_SERIES.map((s) => s.key));

const isSeriesKey = (value: unknown): value is CrmStatsChartSeriesKey =>
  typeof value === 'string' && SERIES_KEYS.has(value);

/** Скрытые серии из сохранённого значения: только известные ключи, не массив - пусто. */
export function parseHiddenSeries(raw: unknown): CrmStatsChartSeriesKey[] {
  return Array.isArray(raw) ? raw.filter(isSeriesKey) : [];
}

/** Скрыть серию или вернуть её. */
export function toggleHiddenSeries(
  hidden: readonly CrmStatsChartSeriesKey[],
  key: CrmStatsChartSeriesKey
): CrmStatsChartSeriesKey[] {
  return hidden.includes(key) ? hidden.filter((k) => k !== key) : [...hidden, key];
}
